<mat-card class="float-card bottom-block text-center">
	<mat-card-header>
		<mat-card-title>404 Сторінка не знайдена!</mat-card-title>
	</mat-card-header>
</mat-card>
